// childSite.js
const state = {
  // 要设置的全局访问的state对象
  ifChildSite: false
}

const getters = {
  // 实时监听state值的变化（最新状态）
  showSite(state) {
    return state.ifChildSite;
  }
}

const mutations = {
  setSite(state, data) {
    state.ifChildSite = data;
  }
}

const actions = {
  changeSite(context, data) {
    context.commit('setSite', data)
  }
}

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/childSite.js